import { ResetHashView } from './ResetHashView.guard'
import { SoftwareTokenMfa } from './SoftwareTokenMfa.guard'
import { ForgotView } from './ForgotView.guard'
import { OtpMfa } from './OtpMfa.guard'
import { MFA } from './MFA'
import { MFASMSConfirm } from './MFASMSConfirm.guard'

interface DefinedGuards {
  [key: string]: (to: any, from: any) => any
}

const definedGuards: DefinedGuards = {
  SoftwareTokenMfa,
  ResetHashView,
  ForgotView,
  OtpMfa,
  MFA,
  MFASMSConfirm
}

export default definedGuards
